export enum BlockchainsEnum {
    TRON = 'tron',
    ETHEREUM = 'ethereum',
    POLYGON = 'polygon',
    SOLANA = 'solana',
    BITCOIN = 'bitcoin',
    BNB = 'bnb'
}
